import type {} from './extend-theme-types';

import { useMemo } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { createTheme } from './create-theme';

type ThemeProviderProps = {
  children: React.ReactNode;
  noSsr?: boolean;
  defaultMode?: string;
  modeStorageKey?: string;
};

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useMemo(() => createTheme(), []);

  return (
    <MuiThemeProvider disableTransitionOnChange theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
